// Importing Images
import HSP_LIGHT from '../assets/Images/HSP_LIGHT.png'
import HSP_DARK from '../assets/Images/HSP_DARK.png'
// import HSP_PROFILE from '../assets/Images/HSP-PROFILE.png'
import HSP_PROFILE from '../assets/Images/profilePic.png'
import PHP_LOGO from '../assets/Images/PHP_logo.png'
import NODE_LOGO from '../assets/Images/node_js_logo.png'
import REACT_WHITE from '../assets/Images/React_White.png'
import REACT_LOGO from '../assets/Images/React_icon.png'
import HTML from '../assets/Images/html.png'
import CSS from '../assets/Images/CSS.png'
import JS from '../assets/Images/JS.png'
import BOOTSTRAP from '../assets/Images/BOOTSTRAP.png'
import PHP from '../assets/Images/PHP.png'
import TAILWIND from '../assets/Images/Tailwind.png'
import NODE from '../assets/Images/Node.png'
import MY_SQL from '../assets/Images/mysql.png'
import MONGO_DB from '../assets/Images/MongoDB.png'
import FIVERR from '../assets/Images/Fiverr.png'

// Project Image Imports
import DENTAL1 from '../assets/Images/Projects/dental1.png'
import DENTAL2 from '../assets/Images/Projects/dental2.png'
import PB1 from '../assets/Images/Projects/phonebook2.png'
import PB2 from '../assets/Images/Projects/phonebook1.png'
import PT1 from '../assets/Images/Projects/partimer1.png'
import PT2 from '../assets/Images/Projects/partimer2_1.png'

export const IMAGES = {
    LIGHT_IMG: HSP_LIGHT,
    DARK_IMG: HSP_DARK,
    HSP_PROFILE: HSP_PROFILE,
    REACT_LOGO: REACT_LOGO,
    PHP_LOGO: PHP_LOGO,
    NODE_LOGO: NODE_LOGO,
    REACT_WHITE: REACT_WHITE,
    HTML: HTML,
    CSS: CSS,
    JS: JS,
    BS: BOOTSTRAP,
    PHP: PHP,
    MONGO: MONGO_DB,
    TAILWIND: TAILWIND,
    NODE: NODE,
    MY_SQL: MY_SQL,
    FIVERR: FIVERR,

    // Project Images
    DENTAL1: DENTAL1,
    DENTAL2: DENTAL2,
    PB1: PB1,
    PB2: PB2,
    PT1: PT1,
    PT2: PT2,
}
